import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { Content } from 'core/layouts';
import { BaasicButton, BaasicDropdown } from 'core/components';

function FacilityAdditionalContactSearchModalTemplate({ facilityAdditionalContactSearchModalViewStore, t }) {
    const {
        contentLoading,
        modalParams,
        contactDepartmentStore,
        downloadContactsReport
    } = facilityAdditionalContactSearchModalViewStore;

    return (
        <React.Fragment>
            <Content loading={contentLoading} >
                <div className="modal__header">
                    <h3 className="modal__header__title">Contacts report</h3>
                </div>
                <div className="modal__body">
                    <div className="row row--form">
                        <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                            <div className="form__group__label">Contact Departments</div>
                            <BaasicDropdown placeholder="Select Contact Departments" store={contactDepartmentStore} multi={true} />
                        </div>
                    </div>
                </div>
            </Content>
            <div className="modal__footer">
                <BaasicButton
                     className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                />
                <BaasicButton
                    className='btn btn--med btn--primary'
                    label='Download'
                    onClick={() => downloadContactsReport()}
                />
            </div>
        </React.Fragment>
    )
}

FacilityAdditionalContactSearchModalTemplate.propTypes = {
    facilityAdditionalContactSearchModalViewStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(FacilityAdditionalContactSearchModalTemplate);
